import { getFormData } from './types';

export default {
    formData: getFormData(),
    loadingFetch: false,
    loadingSave: false,
    isRedoing: false,
};
